import { render } from "./WIconButton.vue?vue&type=template&id=37e0c455"
import script from "./WIconButton.vue?vue&type=script&lang=js"
export * from "./WIconButton.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__